module.exports = __webpack_public_path__ + "static/media/check.764a33d3.svg";